<script setup lang="ts">
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline'
import { computed, onMounted, onUnmounted, ref } from 'vue'

import { t } from '@/services/translation/index.ts'
import { getFailedRequestsCount, useFailedRequestsCount } from '@/services/use-failed-requests-count.ts'

const failedRequestCountTopic = useFailedRequestsCount()

const failureCount = ref<number>(0)
const hasNotifications = computed(() => failureCount.value > 0)

function showAlert(): void {
  alert(t('auth.failed-multiple-times'))
}

function updateFailureCount(): void {
  failureCount.value = getFailedRequestsCount()
}

function onFailedRequestCountUpdated(count: number): void {
  failureCount.value = count
}

onMounted(() => {
  updateFailureCount()
  failedRequestCountTopic.subscribe(onFailedRequestCountUpdated)
})

onUnmounted(() => {
  failedRequestCountTopic.unsubscribe(onFailedRequestCountUpdated)
})
</script>
<template>
  <button
    v-if="hasNotifications"
    class="btn btn-circle text-red-600"
    @click="showAlert"
  >
    <ExclamationCircleIcon class="h-10" />
  </button>
</template>
